import * as React from "react";
import "./TrialLookupsLayout.scss";
import { connect } from "react-redux";
import { RestrictedLayout } from "../../../components/layouts/index";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { ITmdState } from "../../../reducers/index";
import { SettingsSubMenu } from "../../../helpers/subMenuHelper";
import * as AuthenticationHelper from "../../../helpers/authentication";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";

interface ITrialLookupsLayoutProps {
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    loading?: boolean;
    children?: any;
}

interface ITrialLookupsLayoutActions {}

type TrialLookupsLayoutProps = ITrialLookupsLayoutProps &
    ITrialLookupsLayoutActions;

class TrialLookupsLayout extends React.PureComponent<
    TrialLookupsLayoutProps,
    any
> {
    constructor(props: TrialLookupsLayoutProps) {
        super(props);
    }

    render() {
        const { loading, permissions, permission } = this.props;

        let menu: any[] = [];
        if (
            AuthenticationHelper.hasPermission(
                permissions,
                Dtos.Permission.TrialItemUpdate
            )
        ) {
            menu.push({
                icon: undefined,
                title: "Items Templates",
                url: "/settings/trial/itemtemplates",
            });
        }
        if (
            AuthenticationHelper.hasPermission(
                permissions,
                Dtos.Permission.TrialItemUpdate
            )
        ) {
            menu.push({
                icon: undefined,
                title: "Items Components",
                url: "/settings/trial/itemcomponents",
            });
        }
        if (
            AuthenticationHelper.hasPermission(
                permissions,
                Dtos.Permission.CategoriesView
            )
        ) {
            menu.push({
                icon: undefined,
                title: "Item Categories",
                url: "/settings/trial/itemtemplatecategories",
            });
        }
        if (
            AuthenticationHelper.hasPermission(
                permissions,
                Dtos.Permission.TrialTypesView
            )
        ) {
            menu.push({
                icon: undefined,
                title: "Trial Types",
                url: "/settings/trial/trialtypes",
            });
        }

        return (
            <RestrictedLayout
                subMenuItems={loading ? [] : SettingsSubMenu(permissions)}
                sub2MenuItems={loading ? [] : menu}
                loading={loading}
            >
                {permissions.length > 0 &&
                permission &&
                !AuthenticationHelper.hasPermission(permissions, permission) ? (
                    <div className="alert alert-warning d-flex">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>Permission Denied</span>
                    </div>
                ) : (
                    this.props.children
                )}
            </RestrictedLayout>
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: TrialLookupsLayoutProps
): ITrialLookupsLayoutProps => {
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];
    return {
        permissions: permissions,
        permission: ownProps.permission,
        loading: ownProps.loading,
        children: ownProps.children,
    };
};

const mapDispatchToProps = (_dispatch): ITrialLookupsLayoutActions => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TrialLookupsLayout);
